<article class="journey-card">
  <h3 class="journey-card__title">{{ title }}</h3>

  <p class="journey-card__copy">
    {{ bodyText }}
    <button
      type="button"
      class="journey-card__toggle"
      (click)="toggleExpanded()"
    >
      {{ expanded ? 'See Less...' : 'See More...' }}
    </button>
  </p>
</article>
